import React from "react";
import { t } from "@/i18n";
import DialogModal from "@/components/dialogModal";
import AddCompanyAccountWizard from "./addCompanyAccountWizard";
import { useHistory } from "react-router-dom";
import { useDialogModal } from "@/hooks/useDialogModal";
import { Building2 } from "lucide-react";
const AddCompanyAccountModal = ({ open, onClose }) => {
  const history = useHistory();
  const { dialogElement, alert } = useDialogModal();

  const onComplete = async (company) => {
    history.push(`/${company.urlAlias}`);
    onClose();

    await alert(company?.name, t("your_account_has_been_created"), {
      variant: "success",
    });
  };

  return (
    <>
      <DialogModal
        size="sm"
        icon={<Building2 />}
        open={open}
        title={t("navbar.company_dropdown.add_company.title")}
        bodyRenderer={() => <AddCompanyAccountWizard onComplete={onComplete} />}
        submitText={null}
        onCancel={onClose}
      />
      {dialogElement}
    </>
  );
};
export default AddCompanyAccountModal;
export { AddCompanyAccountModal };
